module.exports = __webpack_public_path__ + "img/nodata.ea9b5f9c.png";